/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListenStreakReminderNotificationAction } from './ListenStreakReminderNotificationAction';
import {
    ListenStreakReminderNotificationActionFromJSON,
    ListenStreakReminderNotificationActionFromJSONTyped,
    ListenStreakReminderNotificationActionToJSON,
} from './ListenStreakReminderNotificationAction';

/**
 * 
 * @export
 * @interface ListenStreakReminderNotification
 */
export interface ListenStreakReminderNotification {
    /**
     * 
     * @type {string}
     * @memberof ListenStreakReminderNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ListenStreakReminderNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListenStreakReminderNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ListenStreakReminderNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ListenStreakReminderNotificationAction>}
     * @memberof ListenStreakReminderNotification
     */
    actions: Array<ListenStreakReminderNotificationAction>;
}

/**
 * Check if a given object implements the ListenStreakReminderNotification interface.
 */
export function instanceOfListenStreakReminderNotification(value: object): value is ListenStreakReminderNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ListenStreakReminderNotificationFromJSON(json: any): ListenStreakReminderNotification {
    return ListenStreakReminderNotificationFromJSONTyped(json, false);
}

export function ListenStreakReminderNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListenStreakReminderNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ListenStreakReminderNotificationActionFromJSON)),
    };
}

export function ListenStreakReminderNotificationToJSON(value?: ListenStreakReminderNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ListenStreakReminderNotificationActionToJSON)),
    };
}

